// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"348":"8cf0b5a6","805":"fed5224f"}[chunkId] + ".chunk.css";
};